var exports = {
  "X": "panelToggle__C2THKB",
};

module.exports = exports;
